import { LitElement, html } from "lit";

import { customElement, property } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";

import "@phosphor-icons/webcomponents/PhCheckCircle";
import "@phosphor-icons/webcomponents/PhWarningCircle";
import "@phosphor-icons/webcomponents/PhXCircle";

import { alertItemStyles } from "./alert-item.css";

export type AlertSeverity = "success" | "warning" | "error" | "info";

@customElement("alert-item")
export class AlertItem extends LitElement {
  static override styles = [alertItemStyles];

  @property({ type: String })
  message = "";

  @property({ type: String })
  severity: AlertSeverity = "info";

  private renderIcon() {
    switch (this.severity) {
      case "success":
        return html`<ph-check-circle size="24"></ph-check-circle>`;
      case "warning":
        return html`<ph-warning-circle size="24"></ph-warning-circle>`;
      case "error":
        return html`<ph-x-circle size="24"></ph-x-circle>`;
      case "info":
      default:
        return html`<ph-warning-circle size="24"></ph-warning-circle>`;
    }
  }

  protected override render() {
    return html`
      <div
        class=${classMap({
          alert: true,
          [`alert-${this.severity}`]: true,
        })}
      >
        <div class="alert-icon">${this.renderIcon()}</div>
        <div class="alert-divider"></div>
        <div class="alert-content">
          <span class="alert-message">${this.message}</span>
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "alert-item": AlertItem;
  }
}
